import { useEffect } from "react";

export function useGalleryGestureLock(active = true) {
  useEffect(() => {
    if (!active || typeof document === "undefined") return;

    let lastTouchEnd = 0;

    const preventMultiTouch = (event: TouchEvent) => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    };

    const preventDoubleTapZoom = (event: TouchEvent) => {
      const now = Date.now();
      if (now - lastTouchEnd < 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    };

    const preventGesture = (event: Event) => {
      event.preventDefault();
    };

    const options: AddEventListenerOptions = { passive: false, capture: true };

    document.addEventListener("touchstart", preventMultiTouch, options);
    document.addEventListener("touchmove", preventMultiTouch, options);
    document.addEventListener("touchend", preventDoubleTapZoom, options);
    document.addEventListener("gesturestart", preventGesture, options);
    document.addEventListener("gesturechange", preventGesture, options);
    document.addEventListener("gestureend", preventGesture, options);

    return () => {
      document.removeEventListener("touchstart", preventMultiTouch, options);
      document.removeEventListener("touchmove", preventMultiTouch, options);
      document.removeEventListener("touchend", preventDoubleTapZoom, options);
      document.removeEventListener("gesturestart", preventGesture, options);
      document.removeEventListener("gesturechange", preventGesture, options);
      document.removeEventListener("gestureend", preventGesture, options);
    };
  }, [active]);
}